import {ChangeDetectionStrategy, Component, inject, input} from "@angular/core"
import {MatTooltip} from "@angular/material/tooltip"
import {UtilsService} from "@legacy/helpers/utils"

// A copy-to-clipboard icon that stays hidden until a host element reveals it on hover (see scss).
// Clicking copies the value and stops propagation so it doesn't trigger the surrounding row click.
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-copy-id-button",
    imports: [MatTooltip],
    templateUrl: "./copy-id-button.component.html",
    styleUrl: "./copy-id-button.component.scss",
})
export class CopyIdButtonComponent {
    readonly $value = input<string | number | null | undefined>(undefined, {alias: "value"})
    private readonly utils = inject(UtilsService)

    copy(event: Event, tooltip: MatTooltip): void {
        event.stopPropagation()
        const value = this.$value()
        if (value !== null && value !== undefined) {
            this.utils.copyToClipboardWithTooltip(value, tooltip)
        }
    }
}
